module.exports = __webpack_public_path__ + "static/mg_shot.eb161554.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mg_shot.png
// module id = 194
// module chunks = 35783957827783 107818501498521